export default __webpack_public_path__ + "static/media/michael.0a76cddf.png";